import { translate } from '../../shared/utility';
import { getLocale } from '../../shared/translations';

const getUserPreferences = () => localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).preferences : null;
const getCommunityId = () => localStorage.getItem('communityId') ? localStorage.getItem('communityId') : null;

export default async (methodType, appendApi, bodyData = null) => {
    const userPreferences = getUserPreferences();
    const communityId = getCommunityId();

    const language = userPreferences && userPreferences.preferredLanguageCode ? userPreferences.preferredLanguageCode : '';

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json-patch+json');
    myHeaders.append('Accept-Language', language);

    const token = document.querySelector('meta[name="csrf-token"]');
    if(token) {
        myHeaders.append('XSRF-TOKEN', token.getAttribute('content'));
    }

    const communityApi = communityId && appendApi.indexOf('logout') < 0 ? `${appendApi.indexOf('?') > -1 ? '&' : '?'}communityId=${communityId}` : '';
    const paymentId = userPreferences && Number.isInteger(userPreferences.preferredPaymentAccountId) ? userPreferences.preferredPaymentAccountId : null;
    const paymentApi = Number.isInteger(paymentId) && appendApi.indexOf('logout') < 0 ? `${appendApi.indexOf('?') > -1 || communityId ? '&' : '?'}paymentAccountId=${paymentId}` : '';
    const myInit = {
        method: methodType,
        headers: myHeaders,
        body: bodyData ? JSON.stringify(bodyData) : null,
        credentials: 'include'
    };

    const myFullApi = `/api/v1/${appendApi}${communityApi}${paymentApi}`;

    try {
        const request = new Request(myFullApi, myInit);
        const response = await fetch(request);
        return handleResponses(response);
    } catch (error) {
        return handleResponses(error);
    }
};

const handleResponses = async (response = null) => {
    let errorMessage = '';
    if (response.type) {
        if (response.ok) {
            switch (response.status) {
                case 200:
                case 201:
                    return await response.json();
                default:
                    return null;
            }
        } else {
            const userPreferences = getUserPreferences();
            const locale = getLocale(userPreferences && userPreferences.preferredLanguageCode ? userPreferences.preferredLanguageCode : null);
            let errorData=null;
            switch (response.status) {
                case 400:
                    errorData = await response.json();
                    throw errorData.key==='email_unverified' ? errorData.key : errorData.message;
                    
                case 401:
                    if(!!userPreferences) {
                        localStorage.removeItem('userData');
                        window.location.reload();
                    }
                    errorMessage = translate('errors.general.unauthorized', locale.language);
                    throw errorMessage;
                case 403:
                    errorMessage = translate('errors.general.forbidden', locale.language);
                    throw errorMessage;
                case 404:
                    errorMessage = translate('errors.general.notFound', locale.language);
                    throw errorMessage;
                case 500:
                    errorMessage = translate('errors.general.serverError', locale.language);
                    throw errorMessage;
                default:
                    errorMessage = translate('errors.general.default', locale.language);
                    throw errorMessage;
            }
        }
    } else {
        errorMessage = response && response.message ? response.message : response ? response : 'Missing error!';
        throw errorMessage;
    }
};


// WEBPACK FOOTER //
// ./src/store/actions/fetchData.js